export default "__VITE_ASSET__CLSJ$O1A__"